import { useLocalStorage } from 'hooks';
import { createContext, ReactNode, useMemo } from 'react';
import { Settings } from 'types/availability';
import { DEFAULT_SETTINGS } from 'utils/constants/availability';
import { AVAILABILITY_SETTINGS } from 'utils/constants/localStorageKeys';

type AvailabilitySettingsProviderProps = {
  children?: ReactNode;
};

type AvailabilitySettingsState = {
  settings: Settings;
  changeSettings: (settings: Settings) => void;
};

const AvailabilitySettingsContext = createContext<
  AvailabilitySettingsState | undefined
>(undefined);

export default function AvailabilitySettingsProvider({
  children,
}: AvailabilitySettingsProviderProps) {
  const [settings, setSettings] = useLocalStorage<Settings>(
    AVAILABILITY_SETTINGS,
    DEFAULT_SETTINGS
  );

  const value = useMemo(
    () => ({ settings, changeSettings: setSettings }),
    [settings, setSettings]
  );

  return (
    <AvailabilitySettingsContext.Provider value={value}>
      {children}
    </AvailabilitySettingsContext.Provider>
  );
}

export { AvailabilitySettingsContext, AvailabilitySettingsProvider };
